"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarType = void 0;
var AvatarType;
(function (AvatarType) {
    AvatarType["TEXT"] = "text";
    AvatarType["IMAGE"] = "image";
})(AvatarType || (exports.AvatarType = AvatarType = {}));
